import { Button } from "react-bootstrap";
import { TooltipProvider } from "@bagel-web/components";
import { useAgentViewPreferences } from "./agentViewPreferences";

const MessageOrderingToggle = () => {
  const { showNewestMessagesFirst, setShowNewestMessagesFirst } =
    useAgentViewPreferences();
  return (
    <TooltipProvider
      tooltip={showNewestMessagesFirst ? "Latest first" : "Earliest first"}
    >
      <Button
        variant="secondary"
        onClick={() => setShowNewestMessagesFirst(!showNewestMessagesFirst)}
      >
        <i
          className={
            showNewestMessagesFirst ? "bi-sort-up-alt" : "bi-sort-down"
          }
        />
      </Button>
    </TooltipProvider>
  );
};

export default MessageOrderingToggle;
